@if (sortimentSnittnetto) {
  <rask-header class="ps-0" size="4">{{ "Nettoberäkning" }}</rask-header>
  <rask-div-list [data]="sortimentSnittnetto.rader">
    <rask-list-column header="HS" field="handelssortimentNamn">
      <ng-template let-row="row">
        <span [class.fw-bold]="!row.handelssortimentNamn">
          {{row.handelssortimentNamn || row.handelssortimentsgruppNamn}}
        </span>
      </ng-template>
    </rask-list-column>
    <rask-list-column [header]="rotvardeTitle()" field="rotvarde">
      <ng-template let-row="row">
        <span>
          {{row.rotvarde | number:'1.0-0'}}
        </span>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="TA" field="ta">
      <ng-template let-row="row">
        <span>
          {{row.tillagg | number:'1.0-0'}}
        </span>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Sortimentsnetto" field="sortimentsnetto">
      <ng-template let-row="row">
        <span>
          {{row.kopeskilling | number:'1.0-0'}}
        </span>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Total" field="totalt">
      <ng-template let-row="row">
        <span>
          {{row.totalt | number:'1.0-0'}}
        </span>
      </ng-template>
    </rask-list-column>
  </rask-div-list>
  <div>
    <div class="row rowfooter">
      <div class="col">
        <span >Summa</span>
      </div>
      <div class="col">
        {{ sortimentSnittnetto.summa.rotvarde | number:'1.0-0' }}
      </div>
      <div class="col">
        {{ sortimentSnittnetto.summa.tillagg | number:'1.0-0' }}
      </div>
      <div class="col">
        {{ sortimentSnittnetto.summa.kopeskilling | number:'1.0-0' }}
      </div>
      <div class="col">
        {{ sortimentSnittnetto.summa.totalt | number:'1.0-0' }}
      </div>
    </div>
  </div>
}
